import { NotificationItem } from './notification-item';
import { SectionRI, StudentRI } from 'common-utils/rest-interfaces';
import { pdsUtils } from '../pds-utils';

export type ActivityFeedNotificationContext = {
  section: SectionRI,
  students?: Array<StudentRI>,
  feedName: string,
  activityId: string,
  activitySenderName: string,
  postedAt: Date,
  senderUid: string,
  userType: string
};

export class ActivityFeedNotificationItem extends NotificationItem {

  static NOTIFICATION_TYPE = 'ACTIVITY_FEED_NOTIFICATION';

  feedName: string;
  context: ActivityFeedNotificationContext;

  static generateLookUpKey(sectionUid: string): string {
    return [sectionUid, ActivityFeedNotificationItem.NOTIFICATION_TYPE].join(',');
  }

  constructor(isSeen: boolean, isRead: boolean, context: ActivityFeedNotificationContext) {
    super(ActivityFeedNotificationItem.NOTIFICATION_TYPE, isSeen, isRead);
    this.context = context;
    this.id = this.context.activityId;
    this.feedName = this.context.feedName;
    this.aggregationKey = JSON.stringify({
      sectionUid: this.context.section.uid
    });
  }

  getColorClass(): string {
    return pdsUtils.getSectionColorForClass(this.context.section);
  }

  getSource(): string {
    return this.context.activitySenderName;
  }

  getTitle(): string {
    if (this.context.userType === 'TEACHER') {
      let secondaryDisplay = this.context.section.secondaryDisplay || '';
      secondaryDisplay = secondaryDisplay.length > 15 ? (secondaryDisplay.slice(0, 15) + '...') : secondaryDisplay;
      return `${secondaryDisplay.length > 0 ? secondaryDisplay + ' ' : ''}${this.context.section.primaryDisplay}`;
    }
    return `${this.context.section.primaryDisplay}`;
  }

  getSubtitle(): string {
    if (this.context.userType !== 'PARENT' || this.context.students == null) {
      return '';
    }
    return this.context.students.map((student) => {
      return `${student.firstName} ${student.lastName}`;
    }).join(',');
  }

  getTooltip(): string {
    return `${this.context.activitySenderName}\n${this.context.section.secondaryDisplay} ${this.context.section.primaryDisplay}`;
  }

  getPostedAt(): Date | null {
    return this.context.postedAt;
  }

  getSenderUid(): string | null {
    return this.context.senderUid;
  }

  get lookUpKey(): string {
    return ActivityFeedNotificationItem.generateLookUpKey(this.context.section.uid);
  }
}
